import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

const Questionario: React.FC = () => {
  const router = useRouter();
  useEffect(() => {
    router.push('/pt');
  }, [router]);
  return <></>;
};

export default Questionario;
